<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                Thank you for signing up!
                <br />
                We need to verify your email before proceeding
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background text-center">
        Before we continue, please check your email inbox and click on the confirmation link.
        <br />
        <small>By signing up, you confirm that you accept the <a href="#">Terms of Use</a> and <a href="#"> Privacy Policy</a></small>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerifyEmail',
};
</script>



// WEBPACK FOOTER //
// src/components/auth/VerifyEmail.vue